iScreenWizard.controller('InboxController', function ($scope, $state, $mdDialog, Ajax, ErrorHandler, Dictionary, Gebruikersbericht, userService) {

    var pageSize = 15;

    $scope.gebruikersberichten = [];
    $scope.user = userService.model;
    $scope.page = 1;
    $scope.morePages = true;

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    var refresh = function() {
        $scope.loadGebruikersberichten();
    };
    $scope.refresh = refresh;

    $scope.loadGebruikersberichten = function() {
        if ($scope.morePages) {
            Gebruikersbericht.all(pageSize, $scope.page).then(function (gebruikersberichten) {
                angular.forEach(gebruikersberichten, function(gebruikersbericht) {
                    $scope.gebruikersberichten.push(gebruikersbericht);
                });
                $scope.page =  $scope.page+1;
                if (gebruikersberichten.length < pageSize) {
                    $scope.morePages = false;
                }
            });
        }
    };

    $scope.viewGebruikersbericht = function(gebruikersbericht, ev) {
        Gebruikersbericht.markAsRead(gebruikersbericht);
        gebruikersbericht.gelezen_door_gebruiker = 1;

        $mdDialog.show({
            controller: GebruikersberichtDialogController,
            locals: {
                gebruikersbericht: gebruikersbericht
            },
            templateUrl: '/mijn-iscreen/inbox/show',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true
        });
    };

    function GebruikersberichtDialogController($scope, gebruikersbericht) {
        $scope.gebruikersbericht = gebruikersbericht;
    };
});